import { render, staticRenderFns } from "./EchartsProvinceFootball.vue?vue&type=template&id=83ce9894&scoped=true&"
import script from "./EchartsProvinceFootball.vue?vue&type=script&lang=js&"
export * from "./EchartsProvinceFootball.vue?vue&type=script&lang=js&"
import style0 from "./EchartsProvinceFootball.vue?vue&type=style&index=0&id=83ce9894&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83ce9894",
  null
  
)

export default component.exports